import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots';
import useProjectContents from '../hooks/useProjectContents';

const IncludedDocuments = () => {
    const { projectID } = useParams()
    
    const table = useRef(null)
    const localStorageOrderKey = 'tblIncludedDocumentsOrder'
    const defaultOrder = [[ 2, 'asc' ]]

    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const { currentUser } = useAuthentication();

    const {
        isIncludedDocumentsLoaded,
        includedDocuments,
    } = useProjectContents()
    
    const {
        userHasProjectAccessLevel,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'original.final_version_file_path' },
        { data: 'original.created_at' },
        { data: 'original.reference' },
        { data: 'original.title' },
        { data: 'std_document.name' },
        { data: 'original.owner_user_id' },
        { data: 'original.document_status.name' }
    ]

    const tableSlots = {
        0: filePathSlot,
        1: dateSlot,
        2: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/included_documents/${row.id}`),
        3: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/included_documents/${row.id}`),
        5: ownerSlot,
    }

    const type = project?.project_type?.name
    const tableHead = (
        <tr>
            <th style={{width: '25px'}}>&nbsp;</th>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Type</th>
            <th>Owner</th>
            <th>Status</th>
        </tr>
    )
    
    const showLoading = isLoading || !isUserManagementInitialized || !isIncludedDocumentsLoaded
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        
                        <div className="ibox-title">
                            <h2>Included Documents</h2>
                            
                            { project && userHasProjectAccessLevel(currentUser, project.id, 'CADM_CONTROLLER') &&
                              <Link type="button" className="btn btn-mr btn-primary" to={`/portfolio/${project.id}/included_documents/new`}>New Included Document</Link>
                            }
            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                Included Documents are <b>owned and version-controlled outside of this {type}</b>. References are <b>defined by the owner</b>. Applicability is <b>defined for this {type}</b>.
                            </div>
                            <div key="newText2" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                Included Documents are added and managed by the CADM Controller for this {type}.
                            </div>
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="6"
                                    fetchUrl="/v0/document_statuses"
                                    localStorageKey="included-document-list-statuses"
                                />
                            </div>

                            { showLoading ? <Loading /> : (
                                <GncDataTable
                                    tableRef={table}
                                    data={includedDocuments}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IncludedDocuments
